// extracted by mini-css-extract-plugin
export default {"root":"styles-scoped__root--TBJqR","content":"styles-scoped__content--d70ds","confirm":"styles-scoped__confirm--f_B87","close":"styles-scoped__close--aueLz"};